import React from 'react'
import GenericFormHeaderComponent from '../../genericComponents/forms/GenericFormHeaderComponent'
import TaskManagerDetailPanel from './TaskManagerDetailPanel'

const TaskPreviewModal = (props) => {
    const { task, closeModal, priorityOptions, onPriorityChange, scrollToCommentId } = props

    return (
        <div className="h-full flex flex-col">
            <GenericFormHeaderComponent label={{ contentPrimary: 'Task Details' }} closeModal={closeModal} />
            <div className="flex-1 overflow-y-auto">
                {task ? (
                    <TaskManagerDetailPanel task={task} priorityOptions={priorityOptions} onPriorityChange={onPriorityChange} scrollToCommentId={scrollToCommentId} />
                ) : (
                    <div className="flex items-center justify-center h-full text-fontSlateGrey text-sm">Loading...</div>
                )}
            </div>
        </div>
    )
}

export default TaskPreviewModal
